import {MarginBottom} from 'shared/ui/marginBottom';
import {ConsentError, ConsentText, Container, RegisterWindow, Subtitle, Title} from './styles';
import {LogoSvg} from 'shared/ui/logoSvg';
import {Button, Checkbox, IconButton, Input, InputDate} from '@atomaro/ui-kit';
import {unmaskPhone} from 'shared/helpers';
import {PinInput} from 'react-input-pin-code';
import {GRAYSCALE_91_COLOR, ORANGE_COLOR} from 'shared/consts';
import {useRegister} from '../lib/useRegister';
import {Controller} from 'react-hook-form';
import {ArrowToLeftIcon, PassHide, PassShow} from 'shared/ui/icons';
import {SuggestionsList} from 'shared/ui/suggestionsList';
import {withMask} from 'use-mask-input';

export const Register = () => {
  const {
    control,
    realm,
    step,
    sendCodeText,
    sendCodeButtonType,
    sendCodeButtonDisabled,
    phoneMask,
    errors,
    pinValues,
    showPass,
    showConfirmPass,
    isLoading,
    dadataValues,
    showSuggestions,
    isLoginBtnDisabled,
    emailPattern,
    registerWithMask,
    register,
    onLoginSubmit,
    onBackClick,
    handleSubmit,
    setValue,
    reSendPin,
    setpinValues,
    changeFirstName,
    changeLastName,
    changePatronymic,
    changeCity,
    onPersDataSubmit,
    changeBirthDay,
    onPassSubmit,
    setShowPass,
    setShowConfirmPass,
    changePass,
    changeConfirmPass,
    clearErrors,
    passValidate,
    onSuggestionClck,
    onLoginComplete,
    setIsLoginBtnDisabled,
  } = useRegister();

  const passRules = {
    required: 'Введите пароль',
    minLength: {value: 6, message: 'Минимум 6 символов'},
    pattern: {
      value: /[^\s]+/g,
      message: 'Никаких пробелов',
    },
    validate: passValidate,
  };

  return (
    <Container>
      {step === '1' && (
        <RegisterWindow onSubmit={handleSubmit(onLoginSubmit)}>
          <IconButton
            colorScheme="accent"
            icon={<ArrowToLeftIcon />}
            size="m"
            variant="ghost"
            className="back-button"
            onClick={() => onBackClick(`/oauth/realms/${realm}/login/`)}
          />
          <MarginBottom $value={32}>
            <LogoSvg width={40} height={40} />
          </MarginBottom>
          <Title>Введите свою почту</Title>
          <Subtitle>Нужна для входа в аккаунт</Subtitle>
          <MarginBottom $value={32} style={{width: '100%'}}>
            <Input
              {...register('login', {
                required: true,
                pattern: emailPattern.current,
                onBlur: (event) => {
                  event.target.placeholder = '';
                  if (emailPattern.current.test(event.target.value)) {
                    onLoginComplete();
                  }
                },
                validate: (value) => {
                  if (!value) {
                    setIsLoginBtnDisabled(true);
                    return true;
                  }
                  if (!emailPattern.current.test(value)) {
                    setIsLoginBtnDisabled(true);
                    return 'Некорректный e-mail';
                  }
                  if (value.includes('gmail') || value.includes('icloud')) {
                    setIsLoginBtnDisabled(true);
                    return 'Почтовые ящики от gmail и icloud не принимаются для регистрации';
                  }
                },
                onChange: (event) => {
                  clearErrors('login');
                  if (!emailPattern.current.test(event.target.value)) {
                    setIsLoginBtnDisabled(true);
                  } else {
                    setIsLoginBtnDisabled(false);
                  }
                },
              })}
              autoComplete="email"
              size="l"
              label="Почта"
              error={
                errors?.login
                  ? errors.login?.type === 'required'
                    ? 'Введите e-mail'
                    : errors.login?.type === 'pattern'
                      ? 'Некорректный e-mail'
                      : errors.login?.message || 'Некорректное значение поля'
                  : undefined
              }
            />
          </MarginBottom>
          <Button
            disabled={isLoading || isLoginBtnDisabled}
            label="Далее"
            size="l"
            style={{width: '100%'}}
            onClick={handleSubmit(onLoginSubmit)}
          />
        </RegisterWindow>
      )}
      {step === '2' && (
        <RegisterWindow onSubmit={(event) => event.preventDefault()}>
          <IconButton
            colorScheme="accent"
            icon={<ArrowToLeftIcon />}
            size="m"
            variant="ghost"
            className="back-button"
            onClick={() => onBackClick(`/oauth/realms/${realm}/registration/1`)}
          />
          <MarginBottom $value={32}>
            <LogoSvg width={40} height={40} />
          </MarginBottom>
          <Title>Введите код верификации</Title>
          <Subtitle>Код придет на вашу почту</Subtitle>
          <MarginBottom $value={32}>
            <PinInput
              placeholder=""
              values={pinValues}
              size="lg"
              borderColor={GRAYSCALE_91_COLOR}
              focusBorderColor={ORANGE_COLOR}
              validBorderColor={ORANGE_COLOR}
              onChange={(value, index, values) => {
                setpinValues(values);
              }}
            />
          </MarginBottom>
          <Button
            onClick={reSendPin}
            style={{width: '100%'}}
            size="l"
            label={sendCodeText}
            variant={sendCodeButtonType}
            disabled={sendCodeButtonDisabled || isLoading}
          />
        </RegisterWindow>
      )}
      {step === '3' && (
        <RegisterWindow onSubmit={handleSubmit(onPersDataSubmit)}>
          <IconButton
            colorScheme="accent"
            icon={<ArrowToLeftIcon />}
            size="m"
            variant="ghost"
            className="back-button"
            onClick={() => onBackClick(`/oauth/realms/${realm}/registration/2`)}
          />
          <MarginBottom $value={32}>
            <LogoSvg width={40} height={40} />
          </MarginBottom>
          <Title $mb={32}>Укажите личные данные</Title>

          <Controller
            name="lastName"
            control={control}
            rules={{required: 'Введите фамилию'}}
            render={({field}) => (
              <MarginBottom $value={20} style={{width: '100%'}}>
                <Input
                  name={field.name}
                  value={field.value}
                  size="l"
                  label="Фамилия"
                  error={errors.lastName?.message}
                  onChange={(event) => changeLastName(event, field)}
                />
              </MarginBottom>
            )}
          />
          <Controller
            name="firstName"
            control={control}
            rules={{required: 'Введите имя'}}
            render={({field}) => (
              <MarginBottom $value={20} style={{width: '100%'}}>
                <Input
                  name={field.name}
                  value={field.value}
                  size="l"
                  label="Имя"
                  error={errors.firstName?.message}
                  onChange={(event) => changeFirstName(event, field)}
                />
              </MarginBottom>
            )}
          />
          <Controller
            name="patronymic"
            control={control}
            render={({field}) => (
              <MarginBottom $value={20} style={{width: '100%'}}>
                <Input
                  name={field.name}
                  value={field.value}
                  size="l"
                  label="Отчество"
                  error={errors.patronymic?.message}
                  onChange={(event) => changePatronymic(event, field)}
                />
              </MarginBottom>
            )}
          />
          <MarginBottom $value={20} style={{width: '100%'}}>
            <Input
              {...registerWithMask('phone', [phoneMask.current], {
                required: true,
                pattern: /^((8|\+7)[- ]?)?(\(?\d{3}\)?[- ]?)?[\d\- ]{7,10}$/,
                inputmode: 'numeric',
                validate: (value) => {
                  if (!value) {
                    return true;
                  }
                  if (unmaskPhone(value).length !== 11) {
                    return 'Некорректный номер телефона';
                  }
                },
                onChange: (event) => {
                  clearErrors('phone');
                  if (
                    event.target.value.startsWith('+7 (89') ||
                    event.target.value.startsWith('+7 (7')
                  ) {
                    setValue('phone', '+7 (9');
                  }
                },
                onBeforePaste: (pastedValue) => {
                  if (pastedValue.startsWith('8')) {
                    return `+${pastedValue.replace('8', '7')}`;
                  }

                  if (!pastedValue.startsWith('+')) {
                    return `+${pastedValue}`;
                  }

                  return pastedValue;
                },
              })}
              autoComplete="tel"
              size="l"
              label="Номер телефона"
              error={
                errors?.phone
                  ? errors.phone?.type === 'required'
                    ? 'Введите номер телефона'
                    : errors.phone?.type === 'pattern'
                      ? 'Некорректный номер телефона'
                      : errors.phone?.message || 'Некорректное значение поля'
                  : undefined
              }
            />
          </MarginBottom>

          <Controller
            name="birthday"
            control={control}
            rules={{required: 'Введите дату рождения'}}
            render={({field}) => (
              <MarginBottom $value={20} style={{width: '100%'}}>
                <InputDate
                  name={field.name}
                  activeDate={field.value}
                  size="l"
                  placeholder="Дата рождения"
                  onChange={(date) => changeBirthDay(date, field)}
                  autoComplete="off"
                  maxDate={new Date()}
                  maxYear={new Date().getFullYear()}
                  minYear={1900}
                  error={errors.birthday?.message}
                  ref={withMask('99.99.9999')}
                />
              </MarginBottom>
            )}
          />

          <Controller
            name="city"
            control={control}
            rules={{required: 'Введите город'}}
            render={({field}) => (
              <MarginBottom $value={20} style={{width: '100%', position: 'relative'}}>
                <SuggestionsList
                  list={dadataValues}
                  isShow={showSuggestions}
                  onClick={onSuggestionClck}
                />
                <Input
                  name={field.name}
                  value={field.value}
                  size="l"
                  label="Город"
                  error={errors.city?.message}
                  onChange={(event) => changeCity(event, field)}
                  autoComplete="off"
                />
              </MarginBottom>
            )}
          />

          <Button
            type="submit"
            style={{width: '100%'}}
            size="l"
            label="Далее"
            disabled={isLoading}
          />
        </RegisterWindow>
      )}
      {step === '4' && (
        <RegisterWindow onSubmit={handleSubmit(onPassSubmit)}>
          <IconButton
            colorScheme="accent"
            icon={<ArrowToLeftIcon />}
            size="m"
            variant="ghost"
            className="back-button"
            onClick={() => onBackClick(`/oauth/realms/${realm}/registration/3`)}
          />
          <MarginBottom $value={32}>
            <LogoSvg width={40} height={40} />
          </MarginBottom>
          <Title $mb={32}>Придумайте пароль</Title>

          <Controller
            name="password"
            control={control}
            rules={passRules}
            render={({field}) => (
              <MarginBottom $value={32} style={{width: '100%'}}>
                <Input
                  name={field.name}
                  value={field.value}
                  type={showPass ? 'text' : 'password'}
                  autoComplete="new-password"
                  size="l"
                  label="Пароль"
                  error={errors.password?.message}
                  onChange={(event) => changePass(event, field)}
                  iconSuffix={showPass ? <PassShow /> : <PassHide />}
                  onClickIconSuffix={() => setShowPass(!showPass)}
                  onFocus={() => clearErrors('password')}
                />
              </MarginBottom>
            )}
          />
          <Controller
            name="repeatPassword"
            control={control}
            rules={passRules}
            render={({field}) => (
              <MarginBottom $value={32} style={{width: '100%'}}>
                <Input
                  name={field.name}
                  value={field.value}
                  type={showConfirmPass ? 'text' : 'password'}
                  size="l"
                  label="Повторите пароль"
                  error={errors.repeatPassword?.message}
                  onChange={(event) => changeConfirmPass(event, field)}
                  iconSuffix={showConfirmPass ? <PassShow /> : <PassHide />}
                  onClickIconSuffix={() => setShowConfirmPass(!showConfirmPass)}
                  onFocus={() => clearErrors('repeatPassword')}
                />
              </MarginBottom>
            )}
          />

          <Controller
            name="personalDataConsentAccepted"
            control={control}
            rules={{
              validate: (value) =>
                value === true || 'Необходимо согласиться на обработку персональных данных',
            }}
            render={({field}) => (
              <MarginBottom $value={24} style={{width: '100%'}}>
                <Checkbox
                  className="consent-checkbox"
                  checked={field.value}
                  onChange={(value) => {
                    field.onChange(value);
                    clearErrors('personalDataConsentAccepted');
                  }}
                  label={
                    <ConsentText>
                      Я согласен с{' '}
                      <a
                        href="/personal-data-consent"
                        target="_blank"
                        rel="noreferrer"
                      >
                        политикой обработки персональных данных
                      </a>
                    </ConsentText>
                  }
                />
                {errors.personalDataConsentAccepted?.message && (
                  <ConsentError>
                    {errors.personalDataConsentAccepted.message}
                  </ConsentError>
                )}
              </MarginBottom>
            )}
          />

          <Button
            type="submit"
            style={{width: '100%'}}
            size="l"
            label="Далее"
            disabled={isLoading}
          />
        </RegisterWindow>
      )}
    </Container>
  );
};
